import { useDispatch } from "react-redux";
import classNames from "classnames";

import { clearAllTabs } from "src/common/actions/config.action";

import logo from "_assets/images/180x180.png";

import { HEADER_HEIGHT } from "../constants";

import { CAccount } from "./CAccount";

const Header = () => {
  const dispatch = useDispatch();
  return (
    <header
      className={classNames(
        "sticky top-0 bg-[#053c7f] w-screen flex items-center justify-between z-10",
      )}
      style={{ height: HEADER_HEIGHT, paddingInline: "10%" }}
    >
      <img src={logo} alt="" onClick={() => dispatch(clearAllTabs())} />
      <div className="flex gap-3 items-center">
        <CAccount />
      </div>
    </header>
  );
};

export default Header;
